<template>
	<Slides :slides="slides" class="top-content" />
</template>

<script>
import Slides from './Slides.vue'

export default {
	name: 'SlidesLocations',
	components: {
		Slides,
	},
	data: () => ({
		slides: [
			{
				body: `<div class="title title--3">Jersey City</div><div class="title title--5"><span>DTCC Office</span></div>`,
				background: 'slides/locations/16.jpg',
			},
			{
				body: `<div class="title title--3">Tampa</div><div class="title title--5"><span>DTCC Office</span></div>`,
				background: 'slides/locations/14.jpg',
			},
			{
				body: `<div class="title title--3">Abu Dhabi</div><div class="title title--5"><span>DTCC Office</span></div>`,
				background: 'slides/locations/1.jpg',
			},
			{
				body: `<div class="title title--3">Boston</div><div class="title title--5"><span>DTCC Office</span></div>`,
				background: 'slides/locations/8.jpg',
			},
			{
				body: `<div class="title title--3">Brooklyn</div><div class="title title--5"><span>DTCC Office</span></div>`,
				background: 'slides/locations/15.jpg',
			},
			{
				body: `<div class="title title--3">Brussels</div><div class="title title--5"><span>DTCC Office</span></div>`,
				background: 'slides/locations/22.jpg',
			},
			{
				body: `<div class="title title--3">Chennai</div><div class="title title--5"><span>DTCC Office</span></div>`,
				background: 'slides/locations/5.jpg',
			},
			{
				body: `<div class="title title--3">Dallas</div><div class="title title--5"><span>DTCC Office</span></div>`,
				background: 'slides/locations/12.jpg',
			},
			{
				body: `<div class="title title--3">Dublin</div><div class="title title--5"><span>DTCC Office</span></div>`,
				background: 'slides/locations/19.jpg',
			},
			{
				body: `<div class="title title--3">Hong Kong</div><div class="title title--5"><span>DTCC Office</span></div>`,
				background: 'slides/locations/2.jpg',
			},
			{
				body: `<div class="title title--3">Hyderabad</div><div class="title title--5"><span>DTCC Office</span></div>`,
				background: 'slides/locations/9.jpg',
			},
			{
				body: `<div class="title title--3">London</div><div class="title title--5"><span>DTCC Office</span></div>`,
				background: 'slides/locations/6.jpg',
			},
			{
				body: `<div class="title title--3">Manila</div><div class="title title--5"><span>DTCC Office</span></div>`,
				background: 'slides/locations/13.jpg',
			},
			{
				body: `<div class="title title--3">Shanghai</div><div class="title title--5"><span>DTCC Office</span></div>`,
				background: 'slides/locations/3.jpg',
			},
			{
				body: `<div class="title title--3">Singapore</div><div class="title title--5"><span>DTCC Office</span></div>`,
				background: 'slides/locations/10.jpg',
			},
			{
				body: `<div class="title title--3">Sydney</div><div class="title title--5"><span>DTCC Office</span></div>`,
				background: 'slides/locations/7.jpg',
			},
			{
				body: `<div class="title title--3">Tokyo</div><div class="title title--5"><span>DTCC Office</span></div>`,
				background: 'slides/locations/21.jpg',
			},
			{
				body: `<div class="title title--3">Washington DC</div><div class="title title--5"><span>DTCC Office</span></div>`,
				background: 'slides/locations/11.jpg',
			},
			{
				body: `<div class="title title--3">Wrexham</div><div class="title title--5"><span>DTCC Office</span></div>`,
				background: 'slides/locations/18.jpg',
			},

		]
	})
}
</script>

<style scoped lang="scss">
</style>
